import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Do I need to pay or deposit anything to enter?",
    a: "Absolutely not. This giveaway is 100% free and sponsored by FXTM Africa. You only need to Subscribe, Like, and Comment on YouTube.",
  },
  {
    q: "How are the $500 winners selected?",
    a: "Winners are picked completely at random using an audited YouTube comment picker during our live stream event when the 48-hour timer ends.",
  },
  {
    q: "How do I receive my $500 bonus if I win?",
    a: "Our official channel team replies directly to your winning comment on YouTube with instructions to verify your identity and claim your $500 welcome bonus.",
  },
  {
    q: "Is this the official FXTM Africa channel?",
    a: "Yes — always verify you are on youtube.com/@fxtm.africa. Beware of impersonators in YouTube comments requesting Telegram contacts or private payments. We will never ask you for money.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="faq-section" className="px-4 py-24 sm:px-6">
      <div className="mx-auto max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-12"
        >
          <p className="mb-3 text-xs font-mono font-bold uppercase tracking-[0.3em] text-red-500">Good To Know</p>
          <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            Frequently Asked Questions
          </h2>
        </motion.div>

        <div data-testid="faq-accordion-container" className="space-y-4">
          {FAQS.map((faq, i) => {
            const isOpen = open === i;
            return (
              <motion.div
                key={faq.q}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className={`overflow-hidden rounded-2xl border transition-colors duration-300 ${isOpen ? "border-red-600/40 bg-[#FFFFFF]" : "border-slate-200 bg-[#F4F4F5]"}`}
              >
                <button
                  data-testid={`faq-question-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                >
                  <span className="font-display text-base font-semibold text-slate-900 sm:text-lg">{faq.q}</span>
                  <motion.span animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.3 }} className="shrink-0 text-red-500">
                    <ChevronDown className="h-5 w-5" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                    >
                      <p data-testid={`faq-answer-${i}`} className="px-6 pb-6 text-sm leading-relaxed text-slate-500 sm:text-base">
                        {faq.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
